import { routerReducer, BaseRouterStoreState } from '@ngrx/router-store';
import * as Auth from '../auth/+store/auth.reducers';
import * as App from './app/app.reducer';
import * as Consultation from './consultation/consultation.reducer';
import * as Checkout from './checkout/checkout.reducers';
import * as CheckoutV2 from './checkout-v2/checkout.reducers';
import * as Account from './account/account.reducers';
import * as Orders from './orders/orders.reducers';
import * as Products from './products/products.reducers';
import * as Common from './common/common.reducer';
import * as Inbox from './inbox/inbox.reducer';
import * as Appointment from './appointment/appointment.reducer';
import * as Notification from './notification/notification.reducer';
import * as fromLabReq from './lab-req/lab-req.reducer';
import * as Chat from './chat/chat.reducer';
import * as Subscriptions from './subscriptions/subscriptions.reducer';
import { AppEffects } from './app/app.effects';
import { ConsultationEffects } from './consultation/consultation.effects';
import { CheckoutEffects } from './checkout/checkout.effects';
import { CheckoutV2Effects } from './checkout-v2/checkout.effects';
import { AccountEffects } from './account/account.effects';
import { AuthEffects } from '../auth/+store/auth.effects';
import { OrdersEffects } from './orders/orders.effects';
import { ProductsEffects } from './products/products.effects';
import { InboxEffects } from './inbox/inbox.effects';
import { AppointmentEffects } from './appointment/appointment.effects';
import { NotificationEffects } from './notification/notification.effects';
import { LabReqEffects } from './lab-req/lab-req.effects';
import { ChatEffects } from './chat/chat.effects';
import { SubscriptionEffects } from './subscriptions/subscriptions.effects';

export interface AppState {
  router: BaseRouterStoreState;
  authState: Auth.State;
  app: App.State;
  consultationState: Consultation.State;
  checkout: Checkout.State;
  checkoutV2: CheckoutV2.State;
  account: Account.State;
  orders: Orders.State;
  products: Products.State;
  common: Common.State;
  inbox: Inbox.State;
  appointment: Appointment.State;
  notification: Notification.State;
  chat: Chat.State;
  subscriptions: Subscriptions.State;
}

export const reducers = {
  router: routerReducer,
  // [auth.AUTH_FEATURE_KEY]: auth.reducer,
  // [consultation.FEATURE_KEY]: consultation.reducer,
  // [checkout.FEATURE_KEY]: checkout.reducer
  // NOTE: AOT compilation fail with dynamic assignment
  auth: Auth.reducer,
  app: App.reducer,
  consultation: Consultation.reducer,
  checkout: Checkout.reducer,
  checkoutV2: CheckoutV2.reducer,
  account: Account.reducer,
  orders: Orders.reducer,
  products: Products.reducer,
  common: Common.reducer,
  inbox: Inbox.reducer,
  appointment: Appointment.reducer,
  notification: Notification.reducer,
  labReq: fromLabReq.reducer,
  chat: Chat.reducer,
  subscriptions: Subscriptions.reducer
};

export const effects = [
  ConsultationEffects,
  AppEffects,
  AuthEffects,
  CheckoutEffects,
  CheckoutV2Effects,
  AccountEffects,
  OrdersEffects,
  ProductsEffects,
  InboxEffects,
  AppointmentEffects,
  NotificationEffects,
  LabReqEffects,
  ChatEffects,
  SubscriptionEffects
];
